import React from "react";
import { Grid } from "@material-ui/core";
import { RootStateOrAny, useSelector } from "react-redux";

import { Wrapper, ETimer } from "../styles";
import { checarTitulo } from "../../../../../../utils/sharedFunctions";
import { expressaoCondicionais } from "../Componentes/estruturaExpressao";
import { variaveisCondicionais } from "../Componentes/estrurturaAlgoritmos";
import { ITreinamentoProps } from "../../../../../../models";

export default function TipoCondicionais({ expressao }: ITreinamentoProps) {
  const [tempoRestante, setTempoRestante] = React.useState(60);
  const { listagemDeVariavel, nivelSelecionado } = useSelector(
    (state: RootStateOrAny) => state.appSystem
  );

  React.useEffect(() => {
    if (tempoRestante > 0) {
      setTimeout(() => {
        setTempoRestante(tempoRestante - 1);
      }, 1000);
    } else {
      setTempoRestante(0);
    }

    return () => {};
  }, [tempoRestante]);

  return (
    <Wrapper>
      <h3>Algoritmo Condicionais - {checarTitulo(nivelSelecionado)}</h3>
      <ETimer>
        Tempo restante: <span>{tempoRestante}s</span>
      </ETimer>
      <Grid item className="no-select">
        {listagemDeVariavel &&
          variaveisCondicionais(nivelSelecionado, listagemDeVariavel)}
        <br />
        {listagemDeVariavel &&
          expressaoCondicionais(
            nivelSelecionado,
            expressao,
            listagemDeVariavel
          )}
      </Grid>
    </Wrapper>
  );
}
